import { Container } from '@/components/Containers/Container';
import { useSuspenseQueries } from '@tanstack/react-query';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import z from 'zod';
import { queries } from '@/utils/queryOptions';
import { GanttDataTable } from '@/components/DataTables/GanttDataTable';
import { CampaingsSkeleton } from '@/components/Skeletons/CampaignsSkeleton';

const querySchema = z.object({
	status: z.enum(['Past', 'Future', 'Active']).catch('Active'),
});

export const Route = createFileRoute('/_protected/campaigns/')({
	validateSearch: querySchema,
	component: RouteComponent,
	beforeLoad: () => ({ crumb: 'Overview' }),
	loader: async ({ context }) => {
		await context.queryClient.ensureQueryData(queries.campaigns.list('Past'));
		await context.queryClient.ensureQueryData(queries.campaigns.list('Active'));
		await context.queryClient.ensureQueryData(queries.campaigns.list('Future'));
	},
	pendingComponent: CampaingsSkeleton,
});

function RouteComponent() {
	const data = useSuspenseQueries({
		queries: [
			queries.campaigns.list('Past'),
			queries.campaigns.list('Active'),
			queries.campaigns.list('Future'),
		],
		combine: (result) => {
			// WARN: temp until backend fixes their swagger
			return {
				Past: result[0].data.items,
				// @ts-ignore
				Active: result[1].data.items,
				// @ts-ignore
				Future: result[2].data.items,
				combined: [
					...result[0].data.items,
					...result[1].data.items,
					...result[2].data.items,
				],
			};
		},
	});
	const navigate = useNavigate();

	return (
		<>
			<Container>
				<GanttDataTable
					title="Campaign"
					data={data.combined.map((item) => ({
						startDate: new Date(item.start),
						endDate: item.end ? new Date(item.end) : undefined,
						id: item.id,
						name: item.name,
						color: item.status === 'Active' && 'primary',
					}))}
					onTaskClick={(task) =>
						navigate({
							to: '/campaigns/$campaignId',
							params: { campaignId: task.id },
							search: (prev) => ({ sectionId: prev.sectionId || 'None' }),
						})
					}
				/>
			</Container>
		</>
	);
}
